module.exports = __webpack_public_path__ + "img/volvo_upImg.192f8606.svg";